import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { JYoguiSharedModule } from '../../shared';

import {
    InvoiceItemService,

} from './';

@NgModule({
    imports: [
        JYoguiSharedModule,
    ],
    declarations: [

    ],
    entryComponents: [

    ],
    providers: [
        InvoiceItemService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class JYoguiInvoiceItemModule { }



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/invoice-item/invoice-item.module.ts